var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.showAssessmentAcceleratorIntro && !_vm.showSpotCheckAnimation ? _c('div', {
    class: ['activity-intro', {
      'keyd-check': _vm.isKeyboardCheck
    }]
  }, [_c('h1', {
    class: ['activity-title', {
      'keyd-check': _vm.isKeyboardCheck
    }]
  }, [_vm._v("\n    " + _vm._s(_vm.isKeyboardCheck ? 'Keyboard Check' : _vm.activityTitle.display) + "\n  ")]), _c('h2', {
    staticClass: "activity-subtitle",
    class: {
      'keyd-check': _vm.isKeyboardCheck
    }
  }, [_vm._v("\n    Click the arrow to start\n  ")]), !_vm.isKeyboardCheck && !_vm.showAssessmentAcceleratorIntro ? _c('img', {
    staticClass: "activity-image",
    attrs: {
      "alt": _vm.introImageAlt,
      "src": _vm.introImage
    }
  }) : _vm._e(), _c('intro-button', {
    attrs: {
      "is-loading": _vm.isLoading,
      "end-intro": _vm.endIntro
    }
  })], 1) : _vm.showAssessmentAcceleratorIntro && !_vm.showSpotCheckAnimation ? _c('assessment-accelerator-intro', {
    attrs: {
      "on-complete": _vm.handleAnimationComplete,
      "isAssessmentAcceleratorPreview": _vm.isAssessmentAcceleratorPreview
    }
  }) : _c('spot-check-animation', {
    attrs: {
      "on-complete": _vm.handleAnimationComplete
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }